// extracted by mini-css-extract-plugin
module.exports = {"auction":"NftOtherInfo_auction__3CrFn","withSeparator":"NftOtherInfo_withSeparator__3MNTe"};